@let savedFarms = savedFarms$ | async;

@if (savedFarms && !savedFarms.length) {
  <div class="tw:m-4 tw:text-xs">
    <ion-note color="medium">
      You have no saved farms to display. Create a new farm and come back here to view it.
    </ion-note>
  </div>
}
<ion-list [inset]="false" lines="full" class="no-last-line">
  @if (useMobileLayout$ | async) {
    @for (savedFarm of savedFarms; track savedFarmsListTrackBy($index, savedFarm); let isLastElement = $last) {
      <ion-item-sliding>
        <ion-item [button]="true" (click)="openSavedFarm(savedFarm.id)">
          <ng-container
            [ngTemplateOutlet]="savedFarmItemLabel"
            [ngTemplateOutletContext]="{ isLastElement, savedFarm }"
          >
          </ng-container>
        </ion-item>
        <ion-item-options>
          @if (selectFarmAlertsEnabled$ | async) {
            <ion-item-option
              color="warning"
              [routerLink]="[defaultBackHref ?? '/', 'walking-farm', savedFarm.id, 'alerts']"
            >
              <ion-icon
                slot="icon-only"
                [name]="savedFarm.alertsEnabled ? 'notifications-outline' : 'notifications-off-outline'"
              ></ion-icon>
            </ion-item-option>
          }
          <ion-item-option color="danger" (click)="handleDelete($event, savedFarm)">
            <ion-icon slot="icon-only" name="trash"></ion-icon>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    }
  } @else {
    @for (savedFarm of savedFarms; track savedFarmsListTrackBy($index, savedFarm)) {
      <ion-item [button]="true" (click)="openSavedFarm(savedFarm.id)">
        <ng-container [ngTemplateOutlet]="savedFarmItemLabel" [ngTemplateOutletContext]="{ savedFarm: savedFarm }">
        </ng-container>
        <ion-button slot="end" size="default" color="danger" (click)="handleDelete($event, savedFarm)">
          <ion-icon slot="icon-only" name="trash"></ion-icon>
        </ion-button>
      </ion-item>
    }
  }
</ion-list>

<ng-template #savedFarmItemLabel let-savedFarmUntyped="savedFarm">
  @let savedFarm = asSavedFarm(savedFarmUntyped);
  <ion-label>
    <ion-text color="primary" class="tw:text-md tw:font-bold">{{ savedFarm.name ?? 'No name' }}</ion-text>
    <br />
    <ion-text color="medium" class="tw:text-sm">
      {{ savedFarm.totalProperties }} Properties
      @if (turnoverRateEnabled$ | async) {
        (
        @if (savedFarm.showTurnoverTrend) {
          <ion-icon
            class="tw:align-middle"
            [color]="savedFarm.isTurnoverTrendUp ? 'success' : 'danger'"
            [name]="savedFarm.isTurnoverTrendUp ? 'caret-up-outline' : 'caret-down-outline'"
          ></ion-icon>
        }
        {{ savedFarm.turnoverRate }}% turnover)
      }
    </ion-text>
    <br />
    <ion-text class="tw:text-sm">{{ savedFarm.createdAt | date: 'MM/dd/yyyy' }}</ion-text>
  </ion-label>
  @if (selectFarmAlertsEnabled$ | async) {
    <ion-button
      (click)="openSavedFarmAlerts($event, savedFarm.id)"
      [color]="savedFarm.propertiesWithUnreadAlerts ? 'danger' : savedFarm.alertsEnabled ? 'success' : 'medium'"
      slot="end"
      class="tw:relative"
      shape="round"
    >
      @if (savedFarm.propertiesWithUnreadAlerts) {
        {{ savedFarm.propertiesWithUnreadAlerts }}
      }
      <ion-icon [name]="savedFarm.alertsEnabled ? 'notifications-outline' : 'notifications-off-outline'"> </ion-icon>
    </ion-button>
  }
</ng-template>
